import type { ChatMessage, MessageEntry } from './types';

export const CONVERSATION_NOT_FOUND_ERROR = 'conversation_not_found';

export function isConversationNotFoundError(error: string): boolean {
  return error === CONVERSATION_NOT_FOUND_ERROR;
}

export function createUserMessage(text: string, now: Date = new Date()): ChatMessage {
  return {
    role: 'user',
    content: text,
    ts: now.toISOString(),
  };
}

export function createAssistantMessage(content: string, id: string | null, now: Date = new Date()): ChatMessage {
  return {
    id: id ?? undefined,
    role: 'assistant',
    content,
    ts: now.toISOString(),
  };
}

export function appendEntry(entries: MessageEntry[], entry: MessageEntry): MessageEntry[] {
  return [...entries, entry];
}

export function replaceEntriesForRetry(userMessage: ChatMessage): MessageEntry[] {
  return [{ kind: 'message', data: userMessage }];
}
